'use client';

import {HeaderProps} from '@ui-kit/src/Header/Header.types';
import {useRouter} from 'next/navigation';
import {useCallback} from 'react';

import {StrapiHeader} from './StrapiHeader';

export const StrapiHeaderWithRouter = (
  props: HeaderProps & {
    disableCategoriesSubmenu: boolean;
  },
) => {
  const router = useRouter();
  const handleLinkClick = useCallback<NonNullable<HeaderProps['onLinkClick']>>(
    (link, event) => {
      const basePath = '/catalog';
      const {href} = link;
      if (href?.includes(basePath)) {
        // force soft navigation
        event.preventDefault();
        const path = href.split(basePath)[1] || '/';
        router.push(path);
      }
    },
    [router],
  );

  return <StrapiHeader {...props} handleLinkClick={handleLinkClick} />;
};
